import React, { useEffect, useMemo, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import CryptoJS from "crypto-js";
import logo from "../assets/images/Logo-2.png";
import schoolEduLogo from "../assets/images/schoolEdu-logo.png";
import samagraLogo from "../assets/images/samagra-logo.png";
import pmshreeLogo from "../assets/images/pmshree-logo.png";
import imageRight from "../assets/imageRight.png";
import imageLeft from "../assets/imageLeft.png";
import life from "../assets/Life.png";
import prakarti from "../assets/images/prakarti-img.png";
import SideBar from "./SchoolAdmin/SideBar";
import { useSelector, useDispatch } from "react-redux";
import { apiSlice } from "../redux/api/apiSlice.js";
import { Link } from "react-router-dom";
import { FaBarsStaggered } from "react-icons/fa6";
import axiosConn from "config/axiosConn.js";


const ENCRYPTION_KEY = "dcvasdvgarfrqw444444444434fwedvfwqef43";

const translations = {
  english: {
    certificate: "School Participation",
    ofParticipation: " Certificate",
    campaignName: "Ek Ped Maa Ke Naam 2.0",
    certificateText:
      "This certificate is presented to",
    certificateText2:
      ' in recognition of its active participation in the "Ek Ped Maa Ke Naam 2.0" Campaign by organizing and conducting a tree plantation drive within the school premises and community. The efforts of the school have contributed to protecting Mother Earth and fostering environmental awareness among students, thereby exemplifying the spirit of ',
    lifestyle: 'Mission LiFE—Lifestyle for Environment.',
    schoolUdise: "School UDISE ID:",
    saplingsPlanted: "No. of Saplings Planted:",
    date: "Date:",
    certificateId: "Certificate ID:",
  },
  hindi: {
    certificate: "विद्यालय सहभागिता ",
    ofParticipation: "प्रमाण पत्र",
    campaignName: "एक पेड़ माँ के नाम 2.0",
    certificateText: "यह प्रमाणपत्र ",
    certificateText2:
      "को “एक पेड़ माँ के नाम 2.0” अभियान में उल्लेखनीय सहभागिता हेतु प्रदान किया जाता है। इस अभियान के अंतर्गत विद्यालय ने परिसर एवं समुदाय में वृक्षारोपण कार्यक्रम का सफल आयोजन किया। विद्यालय के इन प्रयासों ने प्रकृति के प्रति सजग उत्तरदायित्व एवं सतत विकास की भावना को सशक्त रूप से अभिव्यक्त किया है। यह पहल ",
    lifestyle: "Mission LiFE—Lifestyle for Environment",
    certificateTextTail:
      " की भावना का उत्कृष्ट उदाहरण प्रस्तुत करती है।",
    schoolUdise: "विद्यालय UDISE ID :",
    saplingsPlanted: "रोपित पौधों की संख्या :",
    date: "दिनांक:",
    certificateId: "प्रमाण पत्र आईडी:",
  },
  telugu: {
          certificate: "పాఠశాల భాగస్వామ్య  ",
          ofParticipation: "ప్రమాణపత్రం ",
          campaignName: "ఏక్ పేడ్ మా కే నామ్ 2.0",
          certificateText: "ఈ ప్రమాణపత్రం ",
          certificateText2: 'ఏక్ పెడ్ మా కే నామ్ 2.0” ప్రచారంలో అత్యుత్తమ భాగస్వామ్యానికి కి అందించబడుతుంది. ఈ ప్రచారంలో భాగంగా, పాఠశాల ఆవరణలో మరియు కమ్యూనిటీలో మొక్కలు నాటే కార్యక్రమాన్ని విజయవంతంగా నిర్వహించింది. పాఠశాల యొక్క ఈ ప్రయత్నాలు ప్రకృతి పట్ల బాధ్యతాయుతమైన దృక్పథాన్ని  మరియు నిరంతర అభివృద్ధి స్ఫూర్తిని బలంగా  చాటింది . ఈ కార్యక్రమం Mission LiFE—Lifestyle for Environment  స్ఫూర్తికి నిదర్శనం.',
          schoolUdise:"పాఠశాల  UDISE ID :",
          saplingsPlanted: "నాటిన మొక్కల సంఖ్య:",
          date: "తేదీ:",
          certificateId: "ప్రమాణపత్రం ID:",
        },
		
		odia: {
          certificate: "ବିଦ୍ୟାଳୟ ସହଭାଗିତା",
          ofParticipation: "ପ୍ରମାଣ ପତ୍ର",
          campaignName: "ଏକ ପେଡ଼ ମା'କେ ନାମ 2.0",
          certificateText: "ଏହି ପ୍ରମାଣପତ୍ର ",
          certificateText2:   `ଏକ ପେଡ଼ ମା'କେ ନାମ 2.0” ଅଭିଯାନରେ ଉଲ୍ଲେଖନୀୟ ସହଭାଗିତା ନିମନ୍ତେ ପ୍ରଦତ୍ତ। ଏହି ଅଭିଯାନ ଅନ୍ତର୍ଗତ ବିଦ୍ୟାଳୟ ନିଜର ପରିସର ଏବଂ ସମାଜରେ ବୃକ୍ଷ ରୋପଣ କାର୍ଯ୍ୟକ୍ରମକୁ ସଫଳ କରିଛନ୍ତି। ବିଦ୍ୟାଳୟର ଏହି ପ୍ରୟାସ ପ୍ରକୃତି ପ୍ରତି ଉତ୍ତରଦାୟିତ୍ୱ ଓ ଏହାର ବିକାଶର ଭାବନାକୁ ଦୃଢ଼ ଭାବରେ ଅଭିବ୍ୟକ୍ତ କରିଛି। ଏହା  Mission LiFE—Lifestyle for Environment ଭାବନାର ଏକ ଉତ୍କୃଷ୍ଟ ଉଦାହରଣ।`,
          schoolUdise:"ବିଦ୍ୟାଳୟ UDISE ID :",
          saplingsPlanted: "ରୋପିତ ବୃକ୍ଷର ସଂଖ୍ୟା :",
          date: "ତାରିଖ:",
          certificateId: "ପ୍ରମାଣପତ୍ର ID:",
        },
 
		
        bengali: {
          certificate: "বিদ্যালয়ে অংশগ্রহণের  ",
          ofParticipation: "প্রমাণ পত্র",
          campaignName: "এক পেড় মা কে নাম 2.0",
          certificateText: "এই প্রমাণপত্রটি ",
          certificateText2:  `এক পেড় মা কে নাম 2.0" অভিযানে, উল্লেখযোগ্য অংশগ্রহণের জন্য প্রদান করা হচ্ছে। এই অভিযানের অধীনে  বিদ্যালয়, তাদের পরিসর এবং এলাকায় সফলভাবে বৃক্ষরোপণ কর্মসূচির আয়োজন করেছে। বিদ্যালয়ের এই প্রচেষ্টাগুলি প্রকৃতির প্রতি সচেতনতার দায়িত্ব এবং নিরন্তর উন্নয়নের ভাবনাকে সুন্দরভাবে প্রকাশ করেছে। এই উদ্যোগটি, Mission LiFE—Lifestyle for Environment –এর ভাবনার একটি চমৎকার দৃষ্টান্ত তুলে ধরে।`,
          schoolUdise:"বিদ্যালয় UDISE ID :",
          saplingsPlanted: "রোপিত চারাগাছের সংখ্যা :",
          date: "তারিখ:",
          certificateId: "প্রমাণপত্র আইডি:",
        },

        punjabi: {
          certificate: "ਸਕੂਲ ਭਾਗੀਦਾਰੀ ",
          ofParticipation: "ਪ੍ਰਮਾਣ-ਪੱਤਰ",
          campaignName: "ਏਕ ਪੇੜ ਮਾਂ ਕੇ ਨਾਮ 2.0",
          certificateText: "ਇਹ ਪ੍ਰਮਾਣ ਪੱਤਰ  ",
          certificateText2: 'ਨੂੰ “ਏਕ ਪੇੜ ਮਾਂ ਕੇ ਨਾਮ 2.0” ਮੁਹਿੰਮ ਵਿੱਚ ਉਲੇਖਣਯੋਗ ਭਾਗੀਦਾਰੀ ਲਈ ਪ੍ਰਦਾਨ ਕੀਤਾ ਜਾਂਦਾ ਹੈ। ਇਸ ਮੁਹਿੰਮ ਦੇ ਤਹਿਤ ਸਕੂਲ ਨੇ ਆਪਣੇ ਚੌਗੀਰਦੇ ਅਤੇ ਭਾਈਚਾਰੇ ਵਿੱਚ ਸਫਲਤਾਪੂਰਕ ਰੁੱਖ ਲਗਾਉਣ ਦਾ ਕਾਰਜ ਕਰਵਾਇਆ ਹੈ। ਸਕੂਲ ਦੀ ਇਹ ਕੋਸ਼ਿਸ਼ਾਂ ਕੁਦਰਤ ਪ੍ਰਤੀ ਜ਼ਿੰਮੇਵਾਰੀ ਅਤੇ ਨਿਰੰਤਰ ਵਿਕਾਸ ਦੀ ਭਾਵਨਾ ਨੂੰ ਮਜ਼ਬੂਤੀ ਨਾਲ ਦਰਸਾਉਂਦੀਆਂ ਹਨ। ਇਹ ਪਹਿਲ Mission LiFE—Lifestyle for Environment ਦੀ ਭਾਵਨਾ ਦੀ ਉਤੱਮ ਉਦਾਹਰਣ ਹੈ।',
          schoolUdise:"ਸਕੂਲ UDISE ID :",
          saplingsPlanted: "ਲਗਾਏ ਗਏ ਬੁੱਟਿਆਂ ਦੀ ਗਿਣਤੀ:",
          date: "ਤਾਰੀਖ:",
          certificateId: "ਪ੍ਰਮਾਣ-ਪੱਤਰ ID:",
        },
		
		kannada: {
          certificate: "ಶಾಲಾ ಭಾಗವಹಿಸುವಿಕೆ ",
          ofParticipation: "ಪ್ರಮಾಣಪತ್ರ",
          campaignName: "ಏಕ್ ಪೇಡ್ ಮಾ ಕೆ ನಾಮ್ 2.0",
          certificateText: "ಈ ಪ್ರಮಾಣಪತ್ರವನ್ನು ",
          certificateText2: 'ಅವರಿಗೆ “ಏಕ್ ಪೇಡ್ ಮಾ ಕೆ ನಾಮ್ 2.0” ಅಭಿಯಾನದಲ್ಲಿನ ಗಮನಾರ್ಹ ಸಹಭಾಗಿತ್ವಕ್ಕಾಗಿ  ನೀಡಲಾಗುತ್ತಿದೆ. ಈ ಅಭಿಯಾನದಡಿಯಲ್ಲಿ, ಶಾಲೆಯು ತನ್ನ ಆವರಣ ಮತ್ತು ಸಮುದಾಯದಲ್ಲಿ ಸಸಿ ನೆಡುವ ಕಾರ್ಯಕ್ರಮವನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಆಯೋಜಿಸಿದೆ. ಶಾಲೆಯ ಈ ಪ್ರಯತ್ನಗಳಿಂದ ಪ್ರಕೃತಿಯ ಬಗ್ಗೆಗಿನ ಜವಾಬ್ದಾರಿಯುತ ಮನೋಭಾವ ಮತ್ತು ಸುಸ್ಥಿರ ಅಭಿವೃದ್ಧಿಯ ಚಿಂತನೆಯನ್ನು ಪ್ರಬಲವಾಗಿ ವ್ಯಕ್ತಪಡಿಸಿದೆ. ಈ ಉಪಕ್ರಮವು Mission LiFE—Lifestyle for Environment (ಪರಿಸರಕ್ಕಾಗಿ ಜೀವನಶೈಲಿ)ಯ ಉತ್ಕೃಷ್ಟ ಉದಾಹರಣೆಯನ್ನು ಪ್ರದರ್ಶಿಸುತ್ತದೆ.',
          schoolUdise:"ಶಾಲೆಯ UDISE ID :",
          saplingsPlanted: "ನೆಡಲಾದ ಸಸಿಗಳ ಸಂಖ್ಯೆ :",
          date: "ದಿನಾಂಕ:",
          certificateId: "ಪ್ರಮಾಣಪತ್ರ ID:",
              },
		
		assamese: {
          certificate: "বিদ্যালয়ৰ অংশগ্ৰহণ",
          ofParticipation: "প্ৰমাণপত্ৰ",
          campaignName: "এক পেড় মা কে নাম 2.0",
          certificateText: "এই প্ৰমাণপত্ৰ প্ৰদান কৰা হৈছে",
          certificateText2: 'বিদ্যালয় পৰিসৰ আৰু সর্ব সাধাৰণ ৰাইজৰ মাজত বৃক্ষ ৰোপণৰ অভিযান চলোৱা "এক পেড় মা কে নাম 2.0" অভিযানত অংশগ্ৰহণ কৰাৰ স্বীকৃতি হিচাপে। বিদ্যালয়ৰ প্ৰচেষ্টাই প্ৰকৃতিৰ প্ৰতি এক গভীৰ দায়িত্ববোধ প্ৰতিফলিত কৰে, যাৰ ফলত Mission LiFE—Lifestyle for Environment মনোভাৱৰ উদাহৰণ পোৱা যায়.',
          schoolUdise:" বিদ্যালয় UDISE ID :",
          saplingsPlanted: " ৰোপণ কৰা উদ্ভিদৰ সংখ্যা:",
          date: "তাৰিখ:",
          certificateId: "প্ৰমাণপত্ৰ ID:",
        
		        },



        urdu: {
          certificate: " اسکول میں شرکت   ",
          ofParticipation: "سرٹیفکیٹ",
          campaignName: "ایک پیڑ ماں کے نام 2.0",
          certificateText: "یہ سرٹیفکیٹ",
          certificateText2:' کو " ایک پیڑ ماں کے نام 2.0" مہم میں نمایاں شرکت کے لیے دیا جاتا ہے۔ اس مہم کے تحت اسکول نے کیمپس اور کمیونٹی میں شجرکاری پروگرام کا کامیاب انعقاد کیا۔ اسکول کی ان کوششوں نے فطرت کے تئیں بیدار ذمہ داری اور پائیدار ترقی کے جذبے کا بھرپور اظہار کیا ہے۔ یہ اقدام Mission LiFE—Lifestyle for Environment کے جذبے کی ایک بہترین مثال پیش کرتا ہے - ',
          schoolUdise:"اسکول UDISE ID :",
          saplingsPlanted: "لگائے گئے پودوں کی تعداد :",
          date: "تاریخ:",
          certificateId: "سرٹیفکیٹ ID:",

        },

		
		malayalam: {
          certificate: "സ്കൂള്‍ പങ്കാളിത്ത  ",
          ofParticipation: "സര്‍ട്ടിഫിക്കറ്റ്",
          campaignName: "ഏക് പേഡ് മാ കേ നാം 2.0",
          certificateText: "ഈ സർട്ടിഫിക്കറ്റ് സമര്‍പ്പിക്കുന്നത് ",
          certificateText2:  'ഏക് പേഡ് മാ കേ നാം 2.0” എന്ന കാമ്പെയ്‌നിൽ ശ്രദ്ധേയമായ പങ്കാളിത്തം നൽകിയതിനാണ്.ഈ പ്രചാരണത്തിന് കീഴിൽ വിദ്യാലയം, വിദ്യാലയപരിസരത്തും  സമൂഹത്തിലും വൃക്ഷത്തൈ നടീല്‍ പരിപാടി വിജയകരമായി സംഘടിപ്പിച്ചു.വിദ്യാലയത്തിന്‍റെ ഈ ശ്രമങ്ങൾ പ്രകൃതിയോടുള്ള അവബോധപൂര്‍ണ്ണമായ ഉത്തരവാദിത്തവും സുസ്ഥിര വികസനമെന്ന ആശയവും ശക്തമായി പ്രകടമാക്കി. ഈ സംരംഭം മിഷൻ Mission LiFE—Lifestyle for Environment എന്ന ആശയത്തിന് ഒരു മികച്ച ഉദാഹരണമാണ്.',
          schoolUdise:" വിദ്യാലയത്തിന്‍റെ UDISE ID :",
          saplingsPlanted: "നട്ടുപിടിപ്പിച്ച സസ്യങ്ങളുടെ എണ്ണം :",
          date: "തീയതി:",
          certificateId: "സര്‍ട്ടിഫിക്കറ്റ് ID:",
        },

         marathi: {
          certificate: "शालेय सहभाग",
          ofParticipation: "प्रमाण पत्र",
          campaignName: "एक पेड़ माँ के नाम 2.0",
          certificateText: "हे प्रमाणपत्र",
          certificateText2: 'एक पेड़ माँ के नाम 2.0" अभियानात उल्लेखनीय सहभाग घेतल्याबद्दल यांना हे प्रमाणपत्र दिले जाते. या अभियानांतर्गत शाळेने परिसर व समाजात वृक्षारोपणाचा कार्यक्रम यशस्वीपणे आयोजित केला. शाळेच्या या प्रयत्नांमुळे निसर्ग आणि शाश्वत विकासाप्रती जाणीवपूर्वक जबाबदारीची भावना प्रकर्षाने व्यक्त झाली आहे. हा उपक्रम Mission LiFE—Lifestyle for Environment या भावनेचे उदाहरण आहे',
          schoolUdise:"विद्यालय UDISE ID :",
          saplingsPlanted: "लागवड केलेल्या रोपांची संख्या :",
          date: "दिनांक:",
          certificateId: "प्रमाण पत्र ID:",
        },

        gujarati: {
          certificate: "શાળા સહભાગિતા પ્રમાણપત્ર  ",
          ofParticipation: "પ્રમાણપત્ર",
          campaignName: "એક પેડ મા કે નામ 2.0",
          certificateText: "આ પ્રમાણપત્ર ",
          certificateText2:  'ને "એક પેડ મા કે નામ 2.0" અભિયાનમાં નોંધપાત્ર સહભાગિતા બદલ આપવામાં આવે છે.આ અભિયાન અંતર્ગત વિદ્યાલયે પરિસર તેમજ સમાજમાં વૃક્ષારોપણ કાર્યક્રમનું સફળ આયોજન કર્યું. શાળાના આ પ્રયત્નો કુદરત પ્રત્યેની જાગૃતિ, જવાબદારી અને સતત વિકાસની ભાવનાને સશકત રીતે અભિવ્યક્ત કરી છે. આ પહેલ Mission LiFE—Lifestyle for Environment ની ભાવનાનું ઉત્તમ ઉદાહરણ રજૂ કરે છે.',
          schoolUdise:" શાળા UDISE ID :",
          saplingsPlanted: "રોપાયેલા છોડની  સંખ્યા :",
          date: "તારીખ:",
          certificateId: "પ્રમાણપત્ર ID:",
        },

        
		tamil: {
          certificate: " பள்ளி பங்கேற்பு ",
          ofParticipation: " சான்றிதழ் ",
          campaignName: " ஏக் பேட் மா கே நாம் 2.0 ",
          certificateText: " இந்த சான்றிதழ் வழங்கப்படுகிறது",
          certificateText2: 'ஏக் பேட் மா கே நாம் 2.0 " இயக்கத்தில் சிறந்த பங்கேற்புக்காக  கௌரவிக்கப்படுகிறது. இந்த பிரச்சாரத்தின் கீழ், பள்ளி வளாகம் மற்றும் சமூகத்தில் ஒரு மரம் நடும் திட்டத்தை வெற்றிகரமாக ஏற்பாடு செய்தது. பள்ளியின்  முயற்சிகள் இயற்கையின்   மீதான  ஆழமான பொறுப்புணர்வை  வெளிப்படுத்துடுகின்றன. இதன் மூலம்  Mission LiFE—Lifestyle for Environment உணர்வுக்கு எடுத்துக்காட்டாக உள்ளது.',
          schoolUdise:" பள்ளி UDISE ID:",
          saplingsPlanted: " நடப்பட்ட நாற்றுகள் எண்ணிக்கை:",
          date: "தேதி:",
          certificateId: "சான்றிதழ் ID:",
             }

};



export default function Certificate({ version = "2.0" }) {
  // const userData = useSelector((state) => state.auth.user);
  const userData = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();

  // Re-read WHO IS LOGGED IN from the cookie (/me) before showing anything.
  // Redux is per-tab: if another school logged in from a second tab, this tab
  // would print the old school's name/UDISE with the new school's sapling count
  // (the count endpoint runs under the cookie). Nothing renders until /me has
  // refreshed the store, so name, UDISE and count all describe the same school.
  const [identityReady, setIdentityReady] = useState(false);
  useEffect(() => {
    let alive = true;
    const req = dispatch(apiSlice.endpoints.loadUser.initiate({}, { forceRefetch: true }));
    Promise.resolve(req).finally(() => { if (alive) setIdentityReady(true); });
    return () => { alive = false; req?.unsubscribe?.(); };
  }, [dispatch]);

  // Ek Ped Maa Ke Naam 3.0 variant. The 3.0 campaign reuses the same certificate
  // layout/wording but: (a) displays the "3.0" campaign name, and (b) sources the
  // saplings count from the school's OWN Create-Event plantation records (events
  // logged from 5 June 2026 onward), NOT the legacy 2.0 sapling data.
  const isV3 = version === "3.0";
  // Swap the campaign version in any display string (all translations hardcode "2.0").
  const v = (str) => (isV3 && str != null ? String(str).replace(/2\.0/g, "3.0") : str);

  // UI state
  const [language, setLanguage] = useState("english"); // "english" means bilingual view, otherwise single-language
  const [schoolName, setSchoolName] = useState(
    ""
  );
  const [location, setLocation] = useState("");
  const [schoolUdise, setSchoolUdise] = useState(userData?.udise_id || userData?.udiseId || "");
  const [saplingsCount, setSaplingsCount] = useState(0);
  const [certId, setCertId] = useState("");
  const [certDate, setCertDate] = useState("");
  const [openSidebar, setOpenSidebar] = useState(false);
   const [matrixCount, setMatrixCount] = useState({});
  const [role, setRole] = useState();
  
  console.log("userData", userData);

  // derived text per language
  const t = useMemo(() => translations[language] || translations.english, [language]);
  const showHindiSection = language === "english"; // bilingual when "english"
  const showEnglishSection = language === "english";

  // Populate from cookie (if present) and set ID/date
  useEffect(() => {
    if (!identityReady) return; // wait for the cookie identity (see above)
    if (userData.name !== '') {
      console.log("userData2", userData);
      // const loc = userData?.eduBlockName + ", " + userData?.district + ", " + userData?.state;
      const loc = [
  userData?.eduBlockName,
  userData?.district,
  userData?.state
]
  .filter(Boolean) // remove null/undefined/empty valuesss
  .join(", ");

      console.log("userdata3",loc)
      setRole(userData.role);
      setSchoolUdise(userData?.udise_id || userData?.udiseId || "220418");
      
      setLocation(`,${loc }`|| '');
      setSchoolName(userData?.school_name || userData?.schooName || "GOVT. SENIOR SECONDARY SCHOOL CHANDHAN");
    }
    // random ID
    const id = String(Math.floor(100000000 + Math.random() * 900000000));
    setCertId(id);

    // date
    const date = new Date();
    const formattedDate = `${String(date.getDate()).padStart(2, "0")}/${String(
      date.getMonth() + 1
    ).padStart(2, "0")}/${date.getFullYear()}`;
    setCertDate(formattedDate);

    
  }, [userData, identityReady]);

  useEffect(() => {
    const getMatricData = async (udise_id) => {
        try {
          // let postData = { udise_id: userData.udise_id };
          const response = await axiosConn("post", `get-matrix-data`);
          if (response.data.status === "success") {
            setMatrixCount(response.data.data);
            // For 2.0 the saplings count is the legacy Ek Ped Maa Ke Naam 2.0 data.
            // For 3.0 it comes from the school's events (fetched separately below).
            if (!isV3) {
              setSaplingsCount(response.data.data?.saplings_planted || 0);
            }
          }
        } catch (error) {
          console.log(error);
        }
      };
      getMatricData(schoolUdise);
  }, [schoolUdise, isV3]);

  // Ek Ped Maa Ke Naam 3.0: pull the saplings count from the school's own
  // Create-Event plantation records (trees planted in events from 5 June 2026 on).
  useEffect(() => {
    if (!isV3 || !identityReady) return;
    const getPlantationCount = async () => {
      try {
        const response = await axiosConn("post", `ekpedmaakenaam3-count`);
        if (response.data?.success) {
          setSaplingsCount(response.data.trees || 0);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getPlantationCount();
  }, [isV3, schoolUdise, identityReady]);

  useEffect(() => {
    // Call backend to record certificate download
    const recordCertificateDownload = async () => {
      try {
        if (schoolUdise) {
          await axiosConn("post", "certificate", { schoolId: schoolUdise });
        }
      } catch (err) {
        // Optionally handle error
        console.error("Failed to record certificate download", err);
      }
    };
    recordCertificateDownload();
  }, [schoolUdise]);

  const handleSidebar = () => {
    setOpenSidebar(!openSidebar);
  };

  async function downloadAsImage() {
    const el = document.getElementById("cert-root");
    if (!el) return;

    // Save original inline style
    const originalStyle = el.getAttribute("style") || "";
    try {
      // Clean borders and padding for capture
      el.style.background = "none";
      el.style.padding = "0";
      el.style.margin = "0";
      el.style.border = "none";
      el.style.boxShadow = "none";

      // Wait for images
      const images = el.getElementsByTagName("img");
      await Promise.all(
        Array.from(images).map((img) => {
          if (!img.complete) {
            return new Promise((resolve, reject) => {
              img.onload = resolve;
              img.onerror = reject;
            });
          }
          return Promise.resolve();
        })
      );

      const canvas = await html2canvas(el, {
        useCORS: true,
        allowTaint: false,
        imageTimeout: 0,
        width: el.scrollWidth,
        height: el.scrollHeight,
        backgroundColor: null,
      });

      const link = document.createElement("a");
      link.href = canvas.toDataURL("image/png");
      link.download = `EcoClubs_Certificate_${isV3 ? "EkPedMaaKeNaam3.0_" : ""}${certId}.png`;
      link.click();
    } finally {
      el.setAttribute("style", originalStyle);
    }
  }

  async function downloadAsPDF() {
    const el = document.getElementById("cert-root");
    if (!el) return;

    const originalStyle = el.getAttribute("style") || "";
    try {
      el.style.width = "1200px";
      el.style.maxWidth = "1200px";
      el.style.backgroundColor = "#fff";
      el.style.padding = "20px";
      el.style.boxSizing = "border-box";

      const images = el.getElementsByTagName("img");
      await Promise.all(
        Array.from(images).map((img) => {
          if (!img.complete) {
            return new Promise((resolve, reject) => {
              img.onload = resolve;
              img.onerror = reject;
            });
          }
          return Promise.resolve();
        })
      );

      const canvas = await html2canvas(el, {
        useCORS: true,
        allowTaint: false,
        scale: 2,
        scrollX: 0,
        scrollY: 0,
        width: el.scrollWidth,
        height: el.scrollHeight,
        windowWidth: el.scrollWidth,
        windowHeight: el.scrollHeight,
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("landscape", "pt", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const ratio = Math.min(pageWidth / canvas.width, pageHeight / canvas.height);
      const imgWidth = canvas.width * ratio;
      const imgHeight = canvas.height * ratio;
      const x = (pageWidth - imgWidth) / 2;
      const y = (pageHeight - imgHeight) / 2;

      pdf.addImage(imgData, "PNG", x, y, imgWidth, imgHeight);
      pdf.save(`EcoClubs_Certificate_${isV3 ? "EkPedMaaKeNaam3.0_" : ""}${certId}.pdf`);
    } finally {
      el.setAttribute("style", originalStyle);
    }
  }

  return (
    <section className="scholdashbrdSec">
      <div className="desktopView" style={{ marginTop: 70, textAlign: "end" }}>
        <Link className="button green bars" onClick={handleSidebar}>
          <FaBarsStaggered size={20} />
        </Link>
      </div>
      <div className={`sidebar ${openSidebar ? "open" : "hideen"}`}>
        <SideBar index={10} role={role} />
      </div>
      <div className="schlDashbrdRgt">
        <div className="row">
          <div className="col-md-12">
            <div className="card-user pageContainer">
              <div className="d-flex justify-content-between align-items-center card-header">
                <h5 className="card-title">{isV3 ? "Ek Ped Maa Ke Naam 3.0 Certificate" : "Certificate"}</h5>
              </div>
              <div className="card-body">
    <div className="certificate-page py-5" style={{ backgroundColor: "#f8f9fa" }}>
      <style>{`
        @import url("https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap");
        body, .certificate-page {
          font-family: "Poppins", sans-serif;
          background-color: #eafef4;
        }
        .cert-scroll-wrapper {
          width: 100%;
          overflow: auto;
          -webkit-overflow-scrolling: touch;
        }
        #cert-root {
          background-color: #fff;
          width: 1200px;
          max-width: none;
          margin: 0 auto;
        }
        .bordered {
          border: 4px solid #257830;
          border-image-width: 30px;
          background: #f2fff4;
          position: relative;
          border-image-repeat: repeat;
          padding: 15px;
        }
        .bordered h1 {
          font-size: 50px;
          line-height: 50px;
          text-transform: uppercase;
          color: #257830;
          letter-spacing: 0em;
          font-weight: 700;
        }
        .bordered h1 span {
          display: block;
          font-size: 25px;
          font-weight: 400;
          line-height: 25px;
          color: #f29620;
          letter-spacing: normal;
        }
        .maxwidth { max-width: 960px; margin: auto; }
        .sideImage, .sideImageLeft {
          position: absolute; bottom: 0;
        }
        .sideImage { right: 0; }
        .sideImageLeft { left: 0; }
        .sideImage img, .sideImageLeft img { max-height:480px; }
        .prakriti { position: absolute; top: 0px; left: -22%; }
        .prakriti img { height: 111px; }
        .bordered p {
          font-style: italic;
          color: #212121;
          font-weight: 400;
          padding-bottom: 10px;
          margin-top:20px;
          font-size: 16px;
        }
        .header {
          background: #dff3e4;
          padding: 12px 40px;
          display: flex;
          align-items: center;
          gap: 3px;
          flex-flow: wrap;
        }
        .header img { height: 76px; }
        .language-selector {
          position: absolute;
          top: -42px;
          right: 10px;
          z-index: 1000;
        }
        .hidden { display: none; }
        #saplingsPlanted{
        padding-bottom:60px; display:block;}
        .max-auto{line-height:1.9rem;}
        @media (max-width: 576px) {
          .bordered h1 { font-size: 50px !important; line-height: 50px !important; }
          .bordered h1 span { font-size: 25px !important; }
          #cert-root { width: 1200px !important; max-width: none !important; }
          .header img { height: 76px !important; }
          .bordered p { font-size: 16px !important; padding-bottom: 10px; }
          .bordered h3 { font-size: 24px !important; }
          .download-actions { display: flex; flex-direction: column; align-items: center; gap: 10px; }
          .download-actions .btn { width: 90%; max-width: 360px; margin: 0 !important; border-radius: 9999px; }
 
        }
      `}</style>

      {/* <header className="header">
        <a href="https://ecoclubs.education.gov.in/" target="_blank" rel="noreferrer">
          <img src={logo} alt="Eco Clubs For Mission LiFE" />
        </a>
        <a href="https://dsel.education.gov.in/" target="_blank" rel="noreferrer">
          <img src={schoolEduLogo} alt="DSEL" />
        </a>
        <a href="https://samagra.education.gov.in/" target="_blank" rel="noreferrer">
          <img src={samagraLogo} alt="Samagra Shiksha" />
        </a>
        <a href="https://pmshri.education.gov.in/" target="_blank" rel="noreferrer">
          <img src={pmshreeLogo} alt="PM SHRI" />
        </a>
      </header> */}

      <main>
        <div className="container position-relative">
          <div className="language-selector">
            <select
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              className="form-select"
            >
            <option value="english">Bilingual</option>
            <option value="hindi">हिन्दी (Hindi)</option>
          <option value="tamil">தமிழ் (Tamil)</option>
            <option value="telugu">తెలుగు (Telugu)</option>
            <option value="marathi">मराठी (Marathi)</option>
            <option value="gujarati">ગુજરાતી (Gujarati)</option>
            <option value="punjabi">ਪੰਜਾਬੀ (Punjabi)</option>
            <option value="bengali">বাংলা (Bengali)</option>
            <option value="malayalam">മലയാളം (Malayalam)</option>
            <option value="kannada">ಕನ್ನಡ (Kannada)</option>
            <option value="odia">ଓଡ଼ିଆ (Odia)</option>
            <option value="assamese">অসমীয়া (Assamese)</option>
            <option value="urdu">اردو (Urdu)</option> 
            </select>
          </div>

          <div className="cert-scroll-wrapper">
            <div id="cert-root" className="p-2 text-center bg-white border position-relative">
              <div className="bordered">
                {/* Decorative side images */}
                <div className="sideImage">
                  <img src={imageRight} alt="Decoration" style={{ maxHeight: language === "english" ? 877 : 480 }} />
                </div>
                <div className="sideImageLeft">
                  <img src={imageLeft} alt="Decoration" style={{ maxHeight: language === "english" ? 877 : 480 }} />
                </div>

                {/* Header logos inside bordered */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <div className="d-flex" style={{ width: "33%", textAlign: "start" }}>
                    <img src={life} alt="Ministry of Education" height={100} style={{ marginRight: 20 }} />
                  </div>
                  <div style={{ width: "33%" }}>
                    <img src={logo} alt="Eco-Clubs Logo" height={80} />
                  </div>
                  <div style={{ width: "33%", textAlign: "end" }}>
                    <img src={schoolEduLogo} alt="State Emblem of India" style={{ width: 293 }} />
                  </div>
                </div>

                <div style={{ position: "relative", display: "inline-block" }}>
                  <div className="prakriti" style={{ left: language === "english" ? "-13%" : "-22%" }}>
                    <img src={prakarti} alt="Prakriti" height={180} />
                  </div>

                  {/* Certificate Title */}
                  <h1>
                    {t.certificate}
                    <span>{t.ofParticipation}</span>
                  </h1>
                  <h3 style={{ color: "#257830" }}>{v(t.campaignName)}</h3>
                </div>

                {/* English section (shown only when bilingual selected) */}
                {showEnglishSection && (
                  <div id="englishSection" className="mx-auto" style={{ maxWidth: 800 }}>
                    <p>
                      {translations.english.certificateText}{" "}
                      <strong style={{ fontSize: 19, display:"block"}}>{schoolName} {location}</strong>{" "}
                      {v(translations.english.certificateText2)}
                      <span style={{ whiteSpace: "nowrap" }}>{translations.english.lifestyle}</span>
                    </p>
                  </div>
                )}

                {/* Selected language section (for any non-English selection) */}
                {!showEnglishSection && (
                  <div id="selectedLangSection" className="mx-auto" style={{ maxWidth: 800 }}>
                    <p>
                      {t.certificateText}{" "}
                      <strong style={{ fontSize: 19, display:"block" }}>{schoolName} {location}</strong>{" "}
                      {v(t.certificateText2)}
                      <span style={{ whiteSpace: "nowrap" }}>{t.lifestyle}</span>
                      {t.certificateTextTail || ""}
                    </p>
                  </div>
                )}

                {/* English-only fields that are labels/values */}
                <div>
                  <span id="schoolUDISE" className="parent-label">
                    <strong>{t.schoolUdise}</strong> {schoolUdise}
                  </span>
                </div>
                <span id="saplingsPlanted" className="parent-label">
                  <strong>{t.saplingsPlanted}</strong> {saplingsCount}
                </span>

                {/* Hindi section (shown only when bilingual) */}
                <div id="hindiSection" className={showHindiSection ? "" : "hidden"}>
                  <h1 style={{ marginTop: 50, letterSpacing: "normal" }}>
                    विद्यालय सहभागिता{" "}
                    <span style={{ fontFamily: "Antic Slab, serif", fontWeight: "normal" }}>प्रमाण पत्र</span>
                  </h1>
                  <h3 style={{ color: "#257830" }}>{v(translations.hindi.campaignName)}</h3>
                  <div className="mx-auto" style={{ maxWidth: 800 }}>
                    <p>
                      {translations.hindi.certificateText}
                      <strong style={{ fontSize: 19, display:"block" }}>
                        {schoolName} {location}
                      </strong>{" "}
                      {v(translations.hindi.certificateText2)}
                      <span style={{ whiteSpace: "nowrap" }}>{translations.hindi.lifestyle}</span>
                      {translations.hindi.certificateTextTail}
                    </p>
                    <span className="parent-label">
                      <strong>{translations.hindi.schoolUdise}</strong> {schoolUdise}
                    </span>
                  </div>
                  <span id="saplingsPlanted" className="parent-label">
                    <strong>{translations.hindi.saplingsPlanted}</strong> {saplingsCount}
                  </span>
                </div>

                {/* Footer with date and cert ID */}
                <div className="maxwidth">
                  <div className="d-flex justify-content-between align-items-center mt-4 px-5">
                    <div>
                      <strong>{t.date}</strong> <span>{certDate}</span>
                    </div>
                    <div className="text-start">
                      <strong><b>{t.certificateId}</b></strong> <em>{certId || "----------"}</em>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Download buttons */}
          <div className="download-actions text-center mt-4">
            <button className="btn btn-success me-2" onClick={downloadAsImage} disabled={!identityReady}>
              Download as Image
            </button>
            <button className="btn btn-outline-secondary" onClick={downloadAsPDF} disabled={!identityReady}>
              Download as PDF
            </button>
          </div>
        </div>
      </main>
    </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}